import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from './Constants'; // Import BASE_URL from your constants

const ChangePassword = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [responseMessage, setResponseMessage] = useState('');
  
  // Regular expression for password validation
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation checks
    if (formData.newPassword !== formData.confirmPassword) {
      setResponseMessage("New password and confirm password do not match.");
      return;
    }

    // Validate new password
    if (!passwordRegex.test(formData.newPassword)) {
      setResponseMessage("Password must be at least 8 characters long, include one uppercase letter, one lowercase letter, one digit, and one special character.");
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      if (!token) {
        setResponseMessage("Unauthorized access, please log in again.");
        return;
      }

      const response = await fetch(`${BASE_URL}change_password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Authorization': `Bearer ${token}`,
        },
        body: new URLSearchParams({
          oldPassword: formData.oldPassword,
          newPassword: formData.newPassword,
          confirmPassword: formData.confirmPassword,
        }),
      });

      const result = await response.json();

      if (!response.ok || !result.status) {
        setResponseMessage(result.error || 'Failed to change password.');
        return;
      }

      // If password change is successful, log out the user and redirect to login page
      localStorage.removeItem('authToken');
      localStorage.removeItem('exp');
      setResponseMessage('Password changed successfully. Please log in again.');
      navigate('/dashboard');
      
    } catch (error) {
      setResponseMessage(`Error: ${error.message}`);
    }
  };

  const handleCancel = () => {
    navigate('/dashboard');
  };

  return (
    <div className="container-scroller">
      <div className="container-fluid page-body-wrapper full-page-wrapper">
        <div className="content-wrapper d-flex align-items-center auth px-0">
          <div className="row w-100 mx-0">
            <div className="col-lg-4 mx-auto">
              <div className="auth-form-light text-left py-5 px-4 px-sm-5">
                <h3 className="font-weight-light text-center">Change Password</h3>
                <br/>
                <form onSubmit={handleSubmit}>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter your old password"
                      value={formData.oldPassword}
                      onChange={handleChange}
                      name="oldPassword"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Enter your new password"
                      value={formData.newPassword}
                      onChange={handleChange}
                      name="newPassword"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      placeholder="Confirm your new password"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                      name="confirmPassword"
                      required
                    />
                  </div>
                  <div className="mt-3 d-grid gap-2">
                    <button
                      type="submit"
                      className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                    >
                      Change Password
                    </button>
                    <button
                      type="button"
                      className="btn btn-block btn-secondary btn-lg font-weight-medium auth-form-btn"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                  </div>
                  {responseMessage && (
                    <div className="mt-3 text-danger text-center">
                      {responseMessage}
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
